<h2 class="mat-h2">Current business (national)</h2>
<table *ngIf="currentBusinessTableData">
  <tr>
    <th></th>
    <th>Total #</th>
    <th [matTooltip]="momentumShortDesc">Δ 4 month</th>
    <th [matTooltip]="momentumLongDesc">Δ PY</th>
    <!-- <th>Budget</th> -->
    <!-- <th>%</th> -->
  </tr>
  <tr>
    <td>National # packs</td>
    <td>{{ currentBusinessTableData.nationalSales.total }}</td>
    <td>{{ currentBusinessTableData.nationalSales.delta4Month }}</td>
    <td>{{ currentBusinessTableData.nationalSales.deltaPY }}</td>
    <!-- <td>{{ currentBusinessTableData.nationalSales.budget }}</td> -->
    <!-- <td>{{ currentBusinessTableData.nationalSales.percentage }}</td> -->
  </tr>
  <tr>
    <td>National sales in €</td>
    <td>{{ currentBusinessTableData.nationalSalesInEuro.total }}</td>
    <td>{{ currentBusinessTableData.nationalSalesInEuro.delta4Month }}</td>
    <td>{{ currentBusinessTableData.nationalSalesInEuro.deltaPY }}</td>
    <!-- <td>{{ currentBusinessTableData.nationalSales.budget }}</td> -->
    <!-- <td>{{ currentBusinessTableData.nationalSales.percentage }}</td> -->
  </tr>
  <tr>
    <td>National # patients</td>
    <td>{{ currentBusinessTableData.patients.total }}</td>
    <td>{{ currentBusinessTableData.patients.delta4Month }}</td>
    <td>{{ currentBusinessTableData.patients.deltaPY }}</td>
    <!-- <td class="white"></td> -->
    <!-- <td class="white"></td> -->
  </tr>
  <!-- <tr>
    <td>Patients ICD</td>
    <td>{{ currentBusinessTableData.patientsICD.total }}</td>
    <td>{{ currentBusinessTableData.patientsICD.deltaPY }}</td>
    <td class="white"></td>
    <td class="white"></td>
    <td class="white"></td>
  </tr> -->
</table>
